import DashboardComponentLink from '../common/DashboardComponentLink';

const ResultsLink = ({ loading }: { loading?: boolean }) => {
  return (
    <DashboardComponentLink
      linkText="Draw Results"
      href={'/results'}
      loading={loading}
    />
  );
};

export default ResultsLink;
